module.exports = __webpack_public_path__ + "static/media/image_part_001.a4281404.jpg";